import { buildModelManager } from "../builder.js";
const DefaultBackfillJobSelection = {
  __typename: true,
  id: true,
  accountingConnectionId: true,
  attempts: true,
  createdAt: true,
  deletedAt: true,
  entityId: true,
  entityType: true,
  externalId: true,
  finalizedAt: true,
  lastError: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "backfillJob";
const pluralModelApiIdentifier = "backfillJobs";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBackfillJobSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "backfillJobGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const BackfillJobManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultBackfillJobSelection,
  operations
);
export {
  BackfillJobManager,
  DefaultBackfillJobSelection
};
//# sourceMappingURL=BackfillJob.js.map
